module.exports = __webpack_public_path__ + "static/media/title-logo.97b89730.png";